declare const Blockly: any;

Blockly.blockRendering.ConstantProvider.prototype.init = function() {
  // topRow的高度
  this.NO_PADDING = 0;
  this.SMALL_PADDING = 3;
  this.MEDIUM_PADDING = 5;
  this.MEDIUM_LARGE_PADDING = 8;
  this.LARGE_PADDING = 10;

  // Offset from the top of the row for placing fields on inline input rows
  // and statement input rows.
  // Matches existing rendering (in 2019).
  this.TALL_INPUT_FIELD_OFFSET_Y = this.MEDIUM_PADDING;

  // tab的高度
  this.TAB_HEIGHT = 15;
  // tab的宽度
  this.TAB_WIDTH = 8;
  // tab在y轴的偏移(输出tab距离顶部的偏移量)
  this.TAB_OFFSET_FROM_TOP = 5;

  this.TAB_VERTICAL_OVERLAP = 2.5;

  // statement上下连接点的宽度和高度
  this.NOTCH_WIDTH = 15;
  this.NOTCH_HEIGHT = 4;

  // This is the minimum width of a block measuring from the end of a rounded
  // corner
  this.MIN_BLOCK_WIDTH = 12;

  this.EMPTY_BLOCK_SPACER_HEIGHT = 16;

  /**
   * dummy input的最小高度
   */
  this.DUMMY_INPUT_MIN_HEIGHT = this.TAB_HEIGHT;

  // 圆角大小
  this.CORNER_RADIUS = 4;

  // Offset from the left side of a block or the inside of a statement input to
  // the left side of the notch.
  this.NOTCH_OFFSET_LEFT = 15;

  this.STATEMENT_BOTTOM_SPACER = 0;
  this.STATEMENT_INPUT_PADDING_LEFT = 20;
  this.BETWEEN_STATEMENT_PADDING_Y = 4;

  // This is the max width of a bottom row that follows a statement input and
  // has inputs inline.
  this.MAX_BOTTOM_WIDTH = 66.5;

  this.START_HAT_HEIGHT = 15;
  this.START_HAT_WIDTH = 100;

  this.SPACER_DEFAULT_HEIGHT = 15;
  //  block块的最小高度
  this.MIN_BLOCK_HEIGHT = 24;

  // inline input的padding
  this.EMPTY_INLINE_INPUT_PADDING = 14.5;
  // input input的高度
  this.EMPTY_INLINE_INPUT_HEIGHT = this.TAB_HEIGHT + 11;

  this.EXTERNAL_VALUE_INPUT_PADDING = 2;

  // statement input的高度
  // this.EMPTY_STATEMENT_INPUT_HEIGHT = this.MIN_BLOCK_HEIGHT;

  // this.START_POINT = Blockly.utils.svgPaths.moveBy(0, 0);

  // 块折叠后的高度+宽度
  // this.JAGGED_TEETH_HEIGHT = 12;
  // this.JAGGED_TEETH_WIDTH = 6;

  this.JAGGED_TEETH = this.makeJaggedTeeth();
  this.NOTCH = this.makeNotch();
  this.START_HAT = this.makeStartHat();
  this.PUZZLE_TAB = this.makePuzzleTab();
  /**
   * 内部圆角
   */
  this.INSIDE_CORNERS = this.makeInsideCorners();
  /**
   * 外部圆角
   */
  this.OUTSIDE_CORNERS = this.makeOutsideCorners();
};

// 更新input,和output的卡槽形状
Blockly.blockRendering.ConstantProvider.prototype.makePuzzleTab = function() {
  const width = this.TAB_WIDTH;
  const height = this.TAB_HEIGHT;

  // 圆形
  // function makeMainPath(up, left) {
  //   const forward = up ? -1 : 1;
  //   return Blockly.utils.svgPaths.arc('a', `90 1 ${up ? 1 : 0}`, width / 2, ` 0,${height * forward}`)
  // }

  // 菱形 l -4,-3.5 0,-8 4,-3.5   l -4,3.5 0,8 4,3.5
  function makeMainPath(up, left, h = height) {
    const forward = up ? -1 : 1;
    return Blockly.utils.svgPaths.line([
      Blockly.utils.svgPaths.point(-width / 2, forward * (height - width) / 2),
      Blockly.utils.svgPaths.point(0, forward * width),
      Blockly.utils.svgPaths.point(width / 2, forward * (height - width) / 2),
    ]);
  }

  // 三角形   l -8, -8  8,-8 z   l 8,8  -8,8
  // function makeMainPath(up, left, h = height) {
  //   const forward = up ? -1 : 1;
  //   const isLeft = left ? 1 : -1;
  //   return Blockly.utils.svgPaths.line([
  //     Blockly.utils.svgPaths.point(-h / 2 * isLeft, forward * h / 2),
  //     Blockly.utils.svgPaths.point(h / 2 * isLeft, forward * h / 2),
  //   ]);
  // }

  const pathUp = makeMainPath(true, true);
  const pathDown = makeMainPath(false, true);
  const pathRightUp = makeMainPath(true, false);
  return {
    width,
    height,
    pathDown,
    pathUp: (h: number) => {
      return makeMainPath(true, true, h);
    },
    pathRightUp
  };
};

// 绘制statement上下连接的路径
export default Blockly.blockRendering.ConstantProvider.prototype.makeNotch = function() {
  const width = this.NOTCH_WIDTH;
  const height = this.NOTCH_HEIGHT;
  const innerWidth = 8;
  const outerWidth = (width - innerWidth) / 2;
  function makeMainPath(dir) {
    return Blockly.utils.svgPaths.line(
        [
          Blockly.utils.svgPaths.point(dir * outerWidth, height),
          Blockly.utils.svgPaths.point(dir * innerWidth, 0),
          Blockly.utils.svgPaths.point(dir * outerWidth, -height)
        ]);
  }
  const pathLeft = makeMainPath(1);
  const pathRight = makeMainPath(-1);
  return {
    width,
    height,
    pathLeft,
    pathRight
  };
};

// 展示下拉弹窗 --- 让其背景色与sourceblock颜色一致
Blockly.FieldDropdown.prototype.showEditor_ = function() {
  this.menu_ = this.dropdownCreate_();
  const parentDiv =   Blockly.DropDownDiv.getContentDiv().parentNode;
  parentDiv.style.backgroundColor = parentDiv.style.borderColor = this.sourceBlock_.colour_;
  this.menu_.render(Blockly.DropDownDiv.getContentDiv());
  Blockly.utils.dom.addClass((this.menu_.getElement()), 'blocklyDropdownMenu');
  Blockly.DropDownDiv.showPositionedByField(
      this, this.dropdownDispose_.bind(this));
  this.menu_.focus();
  if (this.selectedMenuItem_) {
    Blockly.utils.style.scrollIntoContainerView((this.selectedMenuItem_.getElement()), (this.menu_.getElement()));
  }
};

// 变量的下拉列表，去除重命名变量、删除变量选项。
Blockly.FieldVariable.dropdownCreate = function() {
  if (!this.variable_) {
    throw Error('Tried to call dropdownCreate on a variable field with no' +
        ' variable selected.');
  }
  let variableModelList = [];
  if (this.sourceBlock_ && this.sourceBlock_.workspace) {
    const variableTypes = this.getVariableTypes_();
    // Get a copy of the list, so that adding rename and new variable options
    // doesn't modify the workspace's list.
    for (let i = 0; i < variableTypes.length; i++) {
      const variableType = variableTypes[i];
      const variables =
        this.sourceBlock_.workspace.getVariablesOfType(variableType);
      variableModelList = variableModelList.concat(variables);
    }
  }
  variableModelList.sort(Blockly.VariableModel.compareByName);
  const options = [];
  for (let i = 0; i < variableModelList.length; i++) {
    // Set the UUID as the internal representation of the variable.
    options[i] = [variableModelList[i].name, variableModelList[i].getId()];
  }
  return options.length ? options : [['', '']];
};
